// @flow

import React from 'react'
import type { Image as ImageType } from 'types/'
import { markdown } from 'markdown'
import Image from './Image'
import Cta from './Cta'

type Props = {
  image: ImageType,
  title: string,
  text: string,
  url?: string,
  ctaURL: string,
  ctaText: string,
  color: string,
  textColor: string,
}

const Box = ({
  image,
  title,
  text,
  url,
  ctaURL,
  ctaText,
  color,
  textColor,
}: Props) => (
  <div className="flex flex-col h-full col-span-1">
    <div
      className="h-4 border-b-4 border-white border-dashed"
      style={{ backgroundColor: `#${color}` }}
    />
    <div
      key="content"
      className="flex-1 pt-6 pb-12 md:pb-8"
      style={{ backgroundColor: `#${color}` }}
    >
      <div
        key="image-container"
        className="flex flex-col-reverse items-center px-8 pb-6 text-xl font-black justify-cente md:flex-row md:items-center md:justify-start"
        style={{ color: `#${textColor}` }}
        >
          <img src={`${image.dir}${image.name.normal}.${image.extension}`} className="w-auto h-20 mt-6 md:h-12 md:mt-0 md:mr-6" alt={title} />
          {title}
      </div>
      {text &&
        <div
          key="text-container"
          className="max-w-lg px-5 text-base text-center md:px-8 md:text-left"
          dangerouslySetInnerHTML={{ __html: markdown.toHTML(text) }}
        />
      }
      {((typeof url === "string" && url !== "") || 
        (typeof ctaURL === "string" && ctaText !== "")) && (
        <div
          key="cta-wrapper"
          className="flex items-stretch justify-center px-4 pt-8 md:pt-3 md:px-8 md:block"
        >
          <Cta ctaText={ctaText} ctaURL={url || ctaURL} color={textColor} />
        </div>
      )}
    </div>
  </div>
)

export default Box
